import carto from "@carto/carto.js";

export default new carto.Client({
  serverUrl: "https://louse.geodb.host/user/brisbane",
  apiKey: "x2B23xk2uR2KzVjM8LhJSA",
  username: "brisbane",
});



// WEBPACK FOOTER //
// ./src/services/cartoclient.js